module.exports = "/_next/static/images/6f8cea69289b9ff914d48244146885f1-rewards-home-card@0.5x.png";